import { Button, Container, Row, Col } from "reactstrap";

import AppHelmet from "../../components/AppComponents/AppHelmet";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../../components/Navbars/IndexNavbar";
import StrUtils from "../../utils/StrUtils";
import useUser from "../../api/api-hooks/auth/useUser";
import AuthFooter from "../../components/Footers/AuthFooter";

function RegisterExisting() {
  const navigate = useNavigate();
  const { user } = useUser();

  return (
    <>
      <AppHelmet title="We Found Your Existing GrowthCloud Account" />
      <div className="main-content">
        <AdminNavbar bg="" />
        <Container
          fluid
          className="pb-5"
          style={{ height: "calc(100vh - 125px - 3rem)" }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                flexGrow: 1,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Row className="justify-content-center mt-4 mt-sm-6">
                <Col lg="6" xl="5" md="8">
                  <div>
                    <h2 className="text-dark mb-4 mt-5">
                      We found your existing account
                      {StrUtils.getFirstName(user?.Name)
                        ? ", " + StrUtils.getFirstName(user?.Name)
                        : ""}
                      !
                    </h2>
                    <div
                      className="mt-0 font-weight-500 text-dark mb-3"
                      style={{ fontSize: 15 }}
                    >
                      We found an existing account that matches the phone number
                      you provided and we've linked your new information to that
                      account.
                    </div>
                    <div
                      className="mt-0 font-weight-500 text-dark mb-4"
                      style={{ fontSize: 15 }}
                    >
                      Don't think the existing account is yours?&nbsp;
                      <a href="mailto:support@growthcloud.com">
                        Contact Support
                      </a>
                    </div>
                    <Button
                      className="mt-4 mb-0 px-4"
                      color="primary"
                      type="submit"
                      onClick={() => navigate("/clouds", { replace: true })}
                    >
                      Launch GrowthCloud
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="mt-5">
            <AuthFooter />
          </div>
        </Container>
      </div>
    </>
  );
}

export default RegisterExisting;
